module.exports = __webpack_public_path__ + "img/TT4WRadioChecked.56f0a91f.svg";